import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { colors } from 'style/config';
import { Flex, Image, Text } from 'components/ui';

const GiftCardExpandButton = React.forwardRef((props, ref) => {
    const { isNewUserPaymentView, isEditMode, onClick, useGiftCard } = props;

    return (
        <Flex
            ref={ref}
            alignItems='center'
            justifyContent={['space-between', !isEditMode ? 'left' : 'space-between']}
            gap={['6px', '6px', 4]}
            {...(!isNewUserPaymentView && !isEditMode
                ? {
                    paddingX: [4, 5],
                    paddingTop: 4
                }
                : {})}
            borderColor='midGray'
            css={styles.giftCardBox}
            width={['100%', !isEditMode ? 'auto' : '100%']}
            onClick={onClick}
        >
            <Flex
                gap={2}
                alignItems='center'
            >
                <Image
                    src='/img/ufe/payments/giftCardBordered.svg'
                    display='block'
                    width={25}
                    height={16}
                />
                <Text
                    children={useGiftCard}
                    color='blue'
                />
            </Flex>
        </Flex>
    );
});

const styles = {
    giftCardBox: {
        ':hover': { borderColor: colors.black }
    }
};

export default wrapFunctionalComponent(GiftCardExpandButton, 'GiftCardExpandButton');
